import React from "react";
import { SubmissionContainer, ButtonPrimary } from "../styles/primitives";
import DigitalSignatureComponent from "../../../../common/DigitalSignatureComponent";

const SubmissionSection = ({
    formik,
    signaturePadRef,
    fileInputRef,
    cDate,
    ipAddress,
    setIpAddress,
    setCDate,
    setIsSig,
    readOnly,
    readOnlyData,
    registration,
    loading
}) => {
    return (
        <SubmissionContainer>
            <DigitalSignatureComponent 
                formik={formik} 
                signaturePadRef={signaturePadRef} 
                fileInputRef={fileInputRef} 
                cDate={cDate} 
                ipAddress={ipAddress}
                setIpAddress={setIpAddress} 
                setCDate={setCDate} 
                setIsSig={setIsSig} 
                readOnly={readOnly} 
                readOnlyData={readOnlyData} 
            />
            <div className="inputfield" style={{ padding: 0, margin: "8px 0 14px 0", maxWidth: "100%" }}>
                <div className="custom-control custom-checkbox text-left box-tm" style={{ width: "100%" }}>
                    <input 
                        className={"custom-control-input " + (formik.touched.term_condn && formik.errors.term_condn ? " is-invalid" : "")}
                        type="checkbox" 
                        name="term_condn" 
                        onChange={(e) => { formik.setFieldValue('term_condn', e.target.checked); }} 
                        onBlur={formik.handleBlur}
                        checked={formik.values.term_condn || readOnly} 
                        disabled={readOnly} 
                        id="customCheck2" 
                    />
                    <label 
                        className="custom-control-label color-red" 
                        htmlFor="customCheck2" 
                        style={{
                            paddingLeft: "5px", 
                            textBoxEdge: "cap alphabetic", 
                            textBoxTrim: "trim-both", 
                            wordWrap: "break-word", 
                            overflowWrap: "break-word",
                            display: "block",
                            width: "100%",
                            lineHeight: "1.4"
                        }}
                    >
                        I hereby confirm that I have read, understood and accepted all <a href={registration?.linkTandC} target="_blank" rel="noreferrer">Terms and Conditions</a> as set out in the application form that the above subject selections are correct, and understand that there may be changes made based on the academic outcome.
                    </label>
                </div>
            </div>
            {!readOnly && (
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "16px" }}>
                    <ButtonPrimary 
                        type="submit" 
                        disabled={loading || readOnly}
                    >
                        {loading ? (
                            <i className="fas fa-cog fa-spin"></i>
                        ) : (
                            <i className="fa-light fa-circle-check"></i>
                        )}
                        <span>{readOnly ? 'Submitted' : 'Submit'}</span>
                    </ButtonPrimary>
                </div>
            )}
        </SubmissionContainer>
    );
};

export default SubmissionSection;

